import React from "react";
import classNames from "classnames";
import styles from "./VideoErrorBanner.module.scss";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";

export const VideoErrorBanner: React.FC<{
  headline: string;
  subline: string;
}> = ({ headline, subline }) => {
  return (
    <div className={classNames("enforced-dark", styles.banner)}>
      <div className={styles.msg}>
        <ImageWithFallback
          src="https://images.onefootball.com/cw/icons/info-dark.svg"
          alt=""
          height={40}
          width={40}
          className={styles.infoIcon}
        />
        <p className={classNames("title-3-bold-druk", styles.title)}>
          {headline}
        </p>
        <p className={classNames("title-6-bold", styles.subtitle)}>{subline}</p>
      </div>
    </div>
  );
};
